"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const model_1 = require("./model");
const utils_1 = require("./utils");
class SalesSession {
    constructor(session) {
        this.session = session;
        this.id = session.id;
        this.expertId = session.assignedExperts[0];
        this.partner = session.pool;
    }
    getCustomerGraphFields() {
        return this.getAttributeFields(model_1.AttributeTypes.SmartHome, model_1.AttributeKeys.CustomerGraph, false);
    }
    getSalesFields() {
        return this.getAttributeFields(model_1.AttributeTypes.SmartHome, model_1.AttributeKeys.Sales, false);
    }
    getSalesInteractionFields() {
        return this.getAttributeFields(model_1.AttributeTypes.SalesInteractions);
    }
    getOfferDetectionFields() {
        return this.getAttributeFields(model_1.AttributeTypes.OfferDetection);
    }
    getResolutionDetectionFields() {
        return this.getAttributeFields(model_1.AttributeTypes.ResolutionDetection);
    }
    getCustomerSentimentFields() {
        return this.getAttributeFields(model_1.AttributeTypes.CustomerSentiment, model_1.AttributeKeys.Polarity);
    }
    getSalesKeywordFields() {
        return this.getAttributeFields(model_1.AttributeTypes.TailoredSales, model_1.AttributeKeys.Keywords);
    }
    getTailoredOfferRecFields() {
        return this.getAttributeFields(model_1.AttributeTypes.TailoredSales, model_1.AttributeKeys.Recommendations);
    }
    /**
     * @returns either a boolean, null if eligibility is unknown, or undefined if eligibility has not been set yet
     */
    eligibility() {
        var _a;
        return (_a = this.getCustomerGraphFields()) === null || _a === void 0 ? void 0 : _a.isEligible;
    }
    interactionId() {
        var _a;
        return (_a = this.getSalesInteractionFields()) === null || _a === void 0 ? void 0 : _a.interactionId;
    }
    isOfferDetected() {
        var _a;
        return ((_a = this.getOfferDetectionFields()) === null || _a === void 0 ? void 0 : _a.offerDetected) === true;
    }
    isResolutionDetected() {
        var _a;
        return Boolean((_a = this.getResolutionDetectionFields()) === null || _a === void 0 ? void 0 : _a.resolutionDetectedDateTime);
    }
    resolutionScore() {
        var _a, _b;
        return (_b = (_a = this.getResolutionDetectionFields()) === null || _a === void 0 ? void 0 : _a.resolutionScore) !== null && _b !== void 0 ? _b : 0;
    }
    salesKeywords() {
        return Object.keys(this.getSalesKeywordFields() || {});
    }
    tailoredOffer() {
        var _a;
        return (_a = this.getTailoredOfferRecFields()) === null || _a === void 0 ? void 0 : _a.recommendations[0];
    }
    polarityScore() {
        var _a, _b;
        return (_b = (_a = this.getCustomerSentimentFields()) === null || _a === void 0 ? void 0 : _a.score) !== null && _b !== void 0 ? _b : 0;
    }
    enrollmentUrl() {
        var _a;
        return (_a = this.getSalesFields()) === null || _a === void 0 ? void 0 : _a.enrollmentUrl;
    }
    productUrl() {
        var _a;
        return (_a = this.getSalesFields()) === null || _a === void 0 ? void 0 : _a.productUrl;
    }
    getAttributeFields(type, key, useEnvBasedType = true) {
        var _a, _b, _c;
        const attributeType = useEnvBasedType ? utils_1.getEnvironmentAttributeKey(type) : type;
        return (_c = (_b = (_a = this.session.attributesByType) === null || _a === void 0 ? void 0 : _a[attributeType]) === null || _b === void 0 ? void 0 : _b[key !== null && key !== void 0 ? key : this.expertId]) === null || _c === void 0 ? void 0 : _c.fields;
    }
}
exports.SalesSession = SalesSession;
